import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Router from 'next/router';
import { Input, message, notification } from 'antd';
import { chatPremiumLimit, podcastHrefUrl, podcastSlugUrl, retrieveLocally, saveLocally, secToDateDay } from '../../lib/utils';
import { getIsPremiumUser, setIsTyping } from '../../lib/fileUtils';
import { sendChatQuestion } from '../../actions';
import { searchItunes } from '../../lib/searchItunes';
const { Search } = Input;

const chatsInit = [
    { 'time': 0, 'text': 'Examples you can try: \n (Still in beta)' },
    // {'time': 1, 'text': 'Recommend some podcasts involving bank heist'},
    {
        'time': 2,
        'text': 'Show me some podcasts to improve my financial knowledge'
    },
    { 'time': 3, 'text': 'Tell me some podcasts to relax' },
    { 'time': 4, 'text': 'Show me some podcasts recommended by Tim Ferris' },
];

class AppSearchAI extends Component {
    constructor(props) {
        super(props);
        this.state = { fetchingAnswer: false, chats: chatsInit, inputValue: '' };
    }

    onChange = (e) => {
        setIsTyping();
        this.setState({ inputValue: e.target.value });
    }

    onClick = () => {
        const { userDetails } = this.props;
        if (!userDetails || !userDetails.uid) {
            notification.info({
                // duration: 0,
                message: 'Please register or sign in to try AI chatbot',
            });
            return;
        }
        if (!getIsPremiumUser()) {
            // final SharedPreferences prefs = await SharedPreferences.getInstance(); //secToDateDay(
            const lastPlayedTime = retrieveLocally('lastChatTime');
            // const String pattern = 'yyyy-MM-dd';
            const formattedNow = secToDateDay(Date.now() / 1000) + '';
            console.log(lastPlayedTime);
            console.log(formattedNow);
            // prefs.setString('lastPlayedTime', formattedNow);
            saveLocally('lastChatTime', formattedNow)
            if (lastPlayedTime) {
                let todayTrailersCount = 0;
                if (formattedNow == lastPlayedTime) {
                    todayTrailersCount = retrieveLocally('numChatQuestions') || 0;
                    if (todayTrailersCount >= chatPremiumLimit) {
                        notification.info({
                            // duration: 0,
                            message: 'Please move to premium version to ask more than ' +
                                chatPremiumLimit +
                                ' queries per day',
                        });
                        return;
                    }
                    saveLocally('numChatQuestions', todayTrailersCount + 1);
                } else {
                    saveLocally('numChatQuestions', 1);
                }
            }
        }

        const { inputValue, chats } = this.state;
        console.dir(inputValue);

        const chatsNew = [...chats, { time: Date.now(), text: inputValue, isMe: true }];
        this.setState({ chats: chatsNew });
        this.scrollToBottom();
        this.setState({ fetchingAnswer: true });
        sendChatQuestion(inputValue).then((value) => {
            this.setState({ fetchingAnswer: false });
            this._receiveMessage(value);
        }).catch((err) => {
            this.setState({ fetchingAnswer: false });
            // setState(() { });
            notification.error({
                // duration: 0,
                message: 'There was an error fetching info. Please check your connection and try again.',
            });
        });
    }

    _receiveMessage = (value) => {
        const { chats } = this.state;
        const chatsNew = [...chats, { time: Date.now(), text: value }];
        this.setState({ chats: chatsNew, inputValue: '' });
        setTimeout(() => {
            this.addEventListenerDiv();
        }, 300);
        this.scrollToBottom();
    }

    scrollToBottom() {
        this.el.scrollIntoView({ behavior: 'smooth' });
    }

    addEventListenerDiv() {
        const divs = document.getElementsByClassName('gpt');
        console.dir(divs);
        const div = divs[divs.length - 1];
        console.dir(div);
        const seconddivs = div.getElementsByTagName('a');
        console.dir(seconddivs);
        for (const seconddiv of seconddivs) {
            seconddiv.addEventListener("click", e => {
                console.dir(e);
                this.onLinkTap(seconddiv.innerText);
                e.preventDefault();
                e.stopPropagation();
            });
        }
    }

    async onLinkTap(url) {
        // showLoadingModal = true;
        console.dir('url click');
        console.dir(url);
        const hide = message.loading('Loading...', 5);

        if (url.startsWith('http')) {
            console.dir(url);
        } else {
            //// use name itself
            // await utils.waitFor(1000);

            try {
                const query = url;
                const response = await fetch(searchItunes(query), {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    }
                });
                const json = await response.json();
                const podcastsArray = json.results;

                // ItunesData.itunesSearchPodcasts(url)
                //     .then((podcastsArray) {
                console.dir(podcastsArray);
                let podcasts = [];
                // podcastsArray.forEach((podcast) {
                for (let podcast of podcastsArray) {
                    if ((podcast['collectionName'] || '')
                        .toLowerCase() ==
                        (url || '').toLowerCase()) {
                        podcasts
                            .push(podcast);
                        break;
                    }
                }
                // showLoadingModal = false;
                hide();
                // return;
                // utils
                //     .printLog(podcasts.length.toString());
                if (podcasts.length == 1) {
                    /// go directly to series
                    const podcastDataJson =
                        podcasts[0];
                    Router.push(podcastHrefUrl(podcastDataJson.collectionId), podcastSlugUrl(podcastDataJson.collectionName, podcastDataJson.collectionId));
                } else {
                    /// go to further search

                    const textNew = query.replace(/ /g, '-');
                    Router.push(`/search-all?text=${textNew}`);
                    // searchTermGlobalNotifier.value = url;
                    // Navigator.push(
                    //     context,
                    //     CupertinoPageRoute(
                    //         settings: const RouteSettings(
                    //             name: appSearchBodyPage
                    //                 .routeName),
                    //             builder:
                    // (BuildContext context) =>
                    // appSearchBodyPage()));
                }
            } catch (err) {
                hide();
                notification.error({
                    message: 'There was an error loading info. Please try again.',
                    description: '',
                    duration: null
                });
            }
        }
    }

    render() {
        const { fetchingAnswer, inputValue, chats } = this.state;
        // final Map chat = chats.reversed
        //             .toList()[fetchingAnswer ? (index - 1) : index];
        // const isMe = 'isMe' in chat;
        return (
            <div>
                {/* <div>AppSearchAI</div> */}
                <div className='parent'>
                    <div className='main'>
                        <>
                            {chats.map((chat, index) => (
                                'isMe' in chat ? <div key={index} className='isMe'>
                                    {chat.text}
                                </div> :
                                    <div key={index} className='gpt'>
                                        <div dangerouslySetInnerHTML={{ __html: chat.text }}></div>
                                    </div>
                            ))}
                        </>
                        {/* <div ref={el => { this.el = el; }} /> */}
                        <div ref={el => { this.el = el; }} style={{ height: '120px' }}>&nbsp;</div>
                    </div>
                </div>
                <div className='search-bar'>
                    <Search placeholder="Ask me anything about podcasts" value={inputValue} onChange={this.onChange}
                        onSearch={this.onClick} enterButton="Search" size="large" loading={fetchingAnswer} />
                </div>
                <style jsx>
                    {`
                    .parent {
                        // overflow: auto;
                        // height: 60vh;
                    }
                    .main {
                        flex-direction: column;
                        justify-content: left; // flex-end;
                        display: flex;
                        overflow: auto;
                        height: 60vh;
                        padding-bottom: 40px;
                    }
                    .isMe {
                        text-align: right;
                        background: #3b53ce;
                        color: white;
                        padding: 1em 2em;
                        margin-bottom: 1em;
                        border-radius: 12px;
                        // width: 70%;
                        margin-left: 40%;
                    }
                    .gpt {
                        text-align: left;
                        background: #d8ddf5;
                        padding: 1em 2em;
                        margin-bottom: 1em;
                        border-radius: 12px;
                        width: 70%;
                    }
                    .search-bar {
                        position: absolute;
                        bottom: 6rem;
                        left: 50%;
                        width: 50%;
                        transform: translate(-50%, -50%);
                    }
                    `}
                </style>
            </div>
        )
    }
}

AppSearchAI.propTypes = {
    userDetails: PropTypes.object,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
    }
}

export default connect(mapStateToProps, null)(AppSearchAI);